// extracted by mini-css-extract-plugin
export default {"cardHead":"ActiveCustomers_cardHead__lNRve","cardTitle":"ActiveCustomers_cardTitle__gXks1","chart":"ActiveCustomers_chart__BWu5Y"};